import * as actions from '../../actions/types';

const INITIAL_STATE = {
    userTickets: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        },
    }
};

const ticketDashboardReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_USER_TICKETS_LOADING:
            return {
                ...state,
                userTickets: {
                    ...state.userTickets,
                    get: {
                        ...state.userTickets.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.userTickets.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_USER_TICKETS_SUCCESS:
            return {
                ...state,
                userTickets: {
                    ...state.userTickets,
                    get: {
                        ...state.userTickets.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.userTickets.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_USER_TICKETS_FAILURE:
            return {
                ...state,
                userTickets: {
                    ...state.userTickets,
                    get: {
                        ...state.userTickets.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.userTickets.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case actions.GET_USER_TICKETS_RESET:
            return {
                ...state,
                userTickets: {
                    ...state.userTickets.get,
                    get: {
                        ...INITIAL_STATE.userTickets.post,
                        reset: true,
                    },
                },
            }

    }
    return state;
}

export default ticketDashboardReducers;
